{
  "title": "سجل التدقيق",
  "subtitle": "من فعل ماذا ومتى: كل تغيير في الدفاتر والسجلات، الأحدث أولًا.",
  "fields": {
    "when": "الوقت",
    "action": "الإجراء",
    "record": "السجل",
    "actor": "بواسطة",
    "changes": "التغييرات",
    "ip": "عنوان IP",
    "requestId": "مرجع الطلب"
  },
  "list": {
    "entityFilter": "تصفية حسب نوع السجل",
    "allRecords": "كل السجلات",
    "actionFilter": "تصفية حسب الإجراء",
    "allActions": "كل الإجراءات",
    "searchRecords": "ابحث في أنواع السجلات…",
    "searchActions": "ابحث في الإجراءات…",
    "noMatch": "لا توجد نتائج.",
    "filterByActor": "عرض ما فعله {{name}} فقط",
    "actorChip": "بواسطة {{name}}",
    "recordChip": "هذا السجل فقط",
    "system": "النظام",
    "more_zero": "+{{count}} حقل آخر",
    "more_one": "+حقل آخر",
    "more_two": "+حقلان آخران",
    "more_few": "+{{count}} حقول أخرى",
    "more_many": "+{{count}} حقلًا آخر",
    "more_other": "+{{count}} حقل آخر",
    "empty": "لم يُسجَّل شيء بعد.",
    "emptyFiltered": "لا شيء يطابق عوامل التصفية هذه.",
    "clearFilters": "مسح عوامل التصفية"
  },
  "detail": {
    "changes": "الحقول المتغيرة",
    "context": "التفاصيل",
    "field": "الحقل",
    "before": "قبل",
    "after": "بعد",
    "noChanges": "لم تُسجَّل تغييرات في الحقول لهذا الإجراء."
  },
  "history": {
    "action": "السجل",
    "title": "سجل التغييرات",
    "subtitle": "من أنشأ هذا السجل أو عدّله أو رحّله أو أبطله، الأحدث أولًا.",
    "empty": "لا يوجد سجل بعد.",
    "more": "عرض المزيد"
  },
  "entity": {
    "SalesInvoice": "فاتورة مبيعات",
    "Quotation": "عرض سعر",
    "Receipt": "سند قبض",
    "CreditNote": "إشعار دائن",
    "CustomerRefund": "مبلغ مسترد لعميل",
    "Cheque": "شيك",
    "Customer": "عميل",
    "CustomerGroup": "مجموعة عملاء",
    "Purchase": "فاتورة شراء",
    "SupplierPayment": "دفعة لمورد",
    "SupplierReturn": "مرتجع مورد",
    "SupplierRefund": "مبلغ مسترد من مورد",
    "Supplier": "مورد",
    "SupplierGroup": "مجموعة موردين",
    "PosTerminal": "صندوق",
    "PosShift": "وردية صندوق",
    "PosSale": "بيع من نقطة البيع",
    "PosReturn": "مرتجع نقطة البيع",
    "Product": "منتج",
    "ProductCategory": "فئة منتجات",
    "ProductAttribute": "خاصية منتج",
    "Unit": "وحدة",
    "CustomPrice": "سعر مخصص",
    "Warehouse": "مستودع",
    "StockAdjustment": "تسوية مخزون",
    "StockTransfer": "تحويل مخزون",
    "Account": "حساب",
    "AccountRoles": "ربط الحسابات",
    "JournalEntry": "قيد يومية",
    "FiscalYear": "سنة مالية",
    "TaxRate": "نسبة ضريبة",
    "TreasuryAccount": "حساب نقدية أو بنك",
    "PaymentMethod": "طريقة دفع",
    "TreasuryTransfer": "تحويل نقدي أو بنكي",
    "BankStatement": "كشف حساب بنكي",
    "BookFinding": "ملاحظة في سلامة الدفاتر",
    "Expense": "مصروف",
    "ExpenseCategory": "فئة مصروفات",
    "RecurringExpense": "مصروف متكرر",
    "User": "مستخدم",
    "Role": "دور",
    "OrgUnit": "وحدة تنظيمية",
    "WorkLocation": "موقع عمل",
    "CalendarHoliday": "عطلة رسمية",
    "Tenant": "الشركة",
    "CompanyProfile": "ملف الشركة",
    "SalesSettings": "إعدادات المبيعات",
    "SettingGroup": "مجموعة إعدادات",
    "TenantSecret": "سرّ",
    "LockDate": "تاريخ الإقفال",
    "Workflow": "مسار اعتماد",
    "WorkflowRun": "طلب اعتماد",
    "WorkflowDelegation": "تفويض اعتماد",
    "Message": "رسالة",
    "MessageTemplate": "قالب رسالة",
    "MessageOptOut": "إلغاء اشتراك في الرسائل",
    "IssuedDocument": "ملف PDF صادر",
    "PublicLink": "رابط مشاركة",
    "RetentionRule": "قاعدة احتفاظ",
    "LegalHold": "حجز قانوني",
    "PrivacyRequest": "طلب خصوصية",
    "PrivacySubject": "بيانات شخصية",
    "UserInvitation": "دعوة مستخدم",
    "Task": "مهمة",
    "TaskTeam": "فريق",
    "ServiceJob": "أمر خدمة",
    "ServiceVisit": "زيارة خدمة",
    "ServiceFollowUp": "طلب متابعة",
    "ServiceCollection": "تحصيل",
    "ServiceSite": "موقع خدمة",
    "ServicePlace": "مكان في موقع",
    "ServiceSiteTemplate": "قالب موقع",
    "ServiceAsset": "معدّة",
    "ServiceAssetType": "نوع معدات",
    "ServiceContract": "عقد صيانة",
    "Project": "مشروع",
    "ProjectType": "نوع مشروع",
    "ProjectCostCategory": "فئة تكلفة",
    "ProjectCostCategoryMap": "ربط فئات التكاليف",
    "ProjectCostEntry": "قيد تكلفة",
    "ProjectMaterialIssue": "صرف مواد",
    "ProjectRole": "دور تسعير",
    "ProjectPersonRate": "تكلفة ساعة",
    "ProjectTimeEntry": "قيد وقت",
    "ProjectStatusReport": "تقرير حالة",
    "ProjectVariation": "أمر تغييري",
    "ProjectClaim": "مستخلص",
    "ProjectGuarantee": "ضمان",
    "AiSettings": "إعدادات المساعد الذكي",
    "AiConversation": "محادثة مع المساعد",
    "AiRun": "تشغيل المساعد",
    "LoyaltyProgram": "برنامج الولاء",
    "LoyaltyTier": "مستوى الولاء",
    "LoyaltyRule": "قاعدة مكافأة الولاء",
    "LoyaltyMember": "عضو برنامج الولاء",
    "issued_document": "ملف PDF صادر",
    "Employee": "موظف",
    "EmployeeDocument": "وثيقة موظف",
    "PayComponent": "عنصر راتب",
    "PayrollSettings": "إعدادات الرواتب",
    "ContributionRule": "بند اشتراك",
    "PayrollRun": "كشف رواتب",
    "CommissionPlan": "خطة عمولة",
    "CommissionRun": "كشف عمولات"
  },
  "action": {
    "CREATE": "إنشاء",
    "UPDATE": "تعديل",
    "DELETE": "حذف",
    "POST": "ترحيل",
    "VOID": "إبطال",
    "ALLOCATE": "تخصيص",
    "UNALLOCATE": "إلغاء التخصيص",
    "APPROVE": "اعتماد",
    "REJECT": "رفض",
    "CONVERT": "تحويل إلى فاتورة",
    "ARCHIVE": "أرشفة",
    "RESTORE": "استعادة",
    "SET_MAIN": "تعيين كرئيسي",
    "OPEN": "فتح",
    "CLOSE": "إغلاق",
    "REOPEN": "إعادة فتح",
    "REVERSE": "عكس",
    "MATCH": "مطابقة",
    "UNMATCH": "إلغاء المطابقة",
    "ADJUST": "قيد تسوية",
    "COMPLETE": "إتمام",
    "PAY_IN": "إيداع نقدي",
    "PAY_OUT": "سحب نقدي",
    "LOGIN": "تسجيل الدخول",
    "LOGIN_FAILED": "فشل تسجيل الدخول",
    "LOGIN_LOCKED": "قفل الحساب",
    "LOGOUT": "تسجيل الخروج",
    "UNLOCK": "فتح القفل",
    "PASSWORD_CHANGE": "تغيير كلمة المرور",
    "PASSWORD_RESET": "إعادة تعيين كلمة المرور",
    "SET": "ضبط",
    "ATTACH": "إرفاق ملف",
    "DETACH": "إزالة ملف",
    "SUBMIT": "قُدّم للاعتماد",
    "RETURN": "أُعيد للتعديل",
    "WITHDRAW": "سُحب",
    "CANCEL": "أُلغي",
    "REASSIGN": "أُعيد إسناده",
    "REFRESH_APPROVERS": "حُدّث المعتمدون",
    "RETRY": "أُعيدت المحاولة",
    "ACTION_FAILED": "فشل الإجراء النهائي",
    "SAVE_DRAFT": "حُفظت المسودة",
    "DISCARD_DRAFT": "أُهملت المسودة",
    "PUBLISH": "نُشر",
    "ENABLE": "فُعّل",
    "DISABLE": "عُطّل",
    "REORDER": "تغيّر الترتيب",
    "DUPLICATE": "نُسخ",
    "REVOKE": "أُلغي التفويض",
    "MOVE": "نُقل",
    "EMAILED": "أُرسل بالبريد",
    "ISSUE": "أُصدر",
    "INVITED": "أُرسلت الدعوة",
    "INVITATION_ACCEPTED": "قُبلت الدعوة",
    "EXPORT": "صُدّر",
    "IMPORT": "استيراد",
    "ANONYMISE": "أُخفيت الهوية",
    "LIFT": "رُفع",
    "VERIFY": "تم التحقق من الهوية",
    "START": "بدأ",
    "REFUSE": "رُفض",
    "MIGRATE": "نقل البيانات من النظام السابق",
    "ACTIVATE": "تفعيل",
    "IMPERSONATION_START": "دخول فريق الدعم باسم المستخدم",
    "MARK_LOST": "تسجيل كعرض خاسر",
    "START_PROJECT": "بدء مشروع منه",
    "COMMIT": "الالتزام بها للتنفيذ",
    "BACKLOG": "تأجيل المهمة",
    "PAUSE": "إيقاف مؤقت",
    "ACCEPT": "قبول العمل",
    "ASSIGN": "إسناد",
    "CLAIM": "تولّي المهمة من قائمة الفريق",
    "BLOCK": "تعليم كمعطلة",
    "UNBLOCK": "رفع التعطل",
    "REQUEST_DATE": "طلب نقل تاريخ الاستحقاق",
    "ADD_PERSON": "إضافة شخص",
    "REMOVE_PERSON": "إزالة شخص",
    "LINK": "ربط سجل",
    "UNLINK": "إزالة سجل مرتبط",
    "WAITING": "تغيير حالة الانتظار",
    "ITEM_ADD": "إضافة بند",
    "ITEM_UPDATE": "تعديل بند",
    "ITEM_REMOVE": "إزالة بند",
    "PRICE_APPROVAL": "تسجيل موافقة السعر",
    "SCHEDULE": "جدولة زيارة",
    "RESCHEDULE": "إعادة جدولة الزيارة",
    "BEGIN_WORK": "بدء العمل",
    "WORK": "تسجيل العمل المنجز",
    "FINISH": "إنهاء الزيارة",
    "REQUEST": "طلب متابعة",
    "RESUBMIT": "إعادة الإرسال",
    "INVOICE": "إصدار فاتورة",
    "REPORT": "تسجيل تحصيل",
    "GENERATE_PLACES": "أُنشئت الأماكن",
    "DUPLICATE_PLACE": "كُرِّر مكان",
    "ASSETS_ADD": "إضافة معدات",
    "ASSETS_COPY": "نسخ معدات",
    "ASSETS_IMPORT": "استيراد معدات",
    "STATUS": "تغيير الحالة",
    "REPLACE": "استبدال",
    "HOLD": "تعليق",
    "RESUME": "استئناف",
    "UPDATE_FEATURES": "تغيير الوظائف",
    "ADD_MEMBER": "إضافة عضو للفريق",
    "UPDATE_MEMBER": "تعديل عضو في الفريق",
    "REMOVE_MEMBER": "إزالة عضو من الفريق",
    "ADD_NOTE": "إضافة ملاحظة",
    "PIN_NOTE": "تثبيت ملاحظة",
    "UNPIN_NOTE": "إلغاء تثبيت ملاحظة",
    "REMOVE_NOTE": "إزالة ملاحظة",
    "ADD_PRESETS": "إضافة الأنواع القياسية",
    "ADD_NODE": "إضافة جزء إلى الخطة",
    "UPDATE_NODE": "تعديل جزء من الخطة",
    "MOVE_NODE": "نقل جزء من الخطة",
    "REMOVE_NODE": "إزالة جزء من الخطة",
    "ACHIEVE_MILESTONE": "تحقيق معلم رئيسي",
    "UNACHIEVE_MILESTONE": "التراجع عن تحقيق معلم",
    "PROGRESS": "تحديث نسبة الإنجاز",
    "APPLY_TEMPLATE": "إنشاء الخطة من قالب",
    "PLACE_TASK": "وضع مهمة في الخطة",
    "APPLY_PLAN": "تطبيق خطة المساعد",
    "BUDGET_CREATE": "إنشاء موازنة",
    "BUDGET_UPDATE": "تعديل الموازنة",
    "BUDGET_DELETE": "حذف الموازنة",
    "BUDGET_SUBMIT": "تقديم الموازنة للاعتماد",
    "BUDGET_APPROVE": "اعتماد الموازنة",
    "BUDGET_RETURN": "إعادة الموازنة للتعديل",
    "BILLING_ITEM_CREATE": "إضافة بند فوترة",
    "BILLING_ITEM_UPDATE": "تعديل بند فوترة",
    "BILLING_ITEM_DELETE": "حذف بند فوترة",
    "BILLING_ITEM_CANCEL": "إلغاء بند فوترة",
    "BILLING_ITEM_READY": "تعليم بند الفوترة كجاهز",
    "BILLING_ITEM_UNREADY": "تعليم بند الفوترة كغير جاهز",
    "BILLING_ITEMS_ORDER": "إعادة ترتيب بنود الفوترة",
    "BILLING_OVERRIDE": "تعديل العمل القابل للفوترة",
    "BILL": "إصدار فاتورة",
    "BILL_VOID": "إبطال الفوترة",
    "ADD_RATE": "إضافة تكلفة ساعة",
    "REPLACE_RATE": "استبدال تكلفة الساعة",
    "SIGNAL_ACKNOWLEDGE": "الإقرار بتنبيه",
    "SIGNAL_UNACKNOWLEDGE": "إلغاء الإقرار بتنبيه",
    "REFRESH_FIGURES": "تحديث الأرقام",
    "FINALISE": "إنهاء التقرير",
    "CONTRACT_CREATE": "إنشاء العقد",
    "CONTRACT_UPDATE": "تعديل العقد",
    "CONTRACT_ACTIVATE": "تفعيل العقد",
    "CONTRACT_AMEND": "تعديل العقد بملحق",
    "CONTRACT_PRACTICAL_COMPLETION": "تسجيل الاستلام الابتدائي",
    "CONTRACT_CLOSE": "إغلاق العقد",
    "CONTRACT_ADVANCE": "إصدار فاتورة الدفعة المقدمة",
    "CONTRACT_ADVANCE_VOID": "إبطال الدفعة المقدمة",
    "CONTRACT_ADVANCE_REDUCE": "تخفيض الدفعة المقدمة",
    "CONTRACT_ADVANCE_REDUCE_VOID": "إبطال تخفيض الدفعة المقدمة",
    "BOQ_VERSION_CREATE": "إنشاء نسخة من جدول الكميات",
    "BOQ_VERSION_UPDATE": "تعديل نسخة جدول الكميات",
    "BOQ_VERSION_DELETE": "حذف نسخة جدول الكميات",
    "BOQ_IMPORT": "استيراد جدول الكميات",
    "BOQ_BUDGET": "إنشاء موازنة من جدول الكميات",
    "VARIATION_CREATE": "إنشاء أمر تغييري",
    "VARIATION_UPDATE": "تعديل أمر تغييري",
    "VARIATION_REQUEST_APPROVAL": "إرسال الأمر التغييري للاعتماد الداخلي",
    "VARIATION_APPROVE_INTERNAL": "اعتماد الأمر التغييري داخليًا",
    "VARIATION_RETURN_INTERNAL": "إعادة الأمر التغييري داخليًا",
    "VARIATION_SUBMIT": "تقديم الأمر التغييري للعميل",
    "VARIATION_APPROVE": "اعتماد الأمر التغييري",
    "VARIATION_REJECT": "رفض الأمر التغييري",
    "VARIATION_WITHDRAW": "سحب الأمر التغييري",
    "CLAIM_CREATE": "إنشاء مستخلص",
    "CLAIM_UPDATE": "تعديل المستخلص",
    "CLAIM_DELETE": "حذف المستخلص",
    "CLAIM_REQUEST_APPROVAL": "إرسال المستخلص للاعتماد الداخلي",
    "CLAIM_APPROVE_INTERNAL": "اعتماد المستخلص داخليًا",
    "CLAIM_RETURN_INTERNAL": "إعادة المستخلص داخليًا",
    "CLAIM_SUBMIT": "تقديم المستخلص للعميل",
    "CLAIM_REJECT": "رفض المستخلص",
    "CLAIM_CERTIFIED_FIGURES": "إدخال الأرقام المعتمدة",
    "CLAIM_CERTIFY": "اعتماد المستخلص",
    "CLAIM_VOID": "إبطال المستخلص",
    "RETENTION_RELEASE": "الإفراج عن المحتجزات",
    "RETENTION_RELEASE_VOID": "إبطال الإفراج عن المحتجزات",
    "RETENTION_FORFEIT": "التنازل عن المحتجزات",
    "RETENTION_FORFEIT_VOID": "إبطال التنازل عن المحتجزات",
    "GUARANTEE_CREATE": "إضافة ضمان",
    "GUARANTEE_UPDATE": "تعديل ضمان",
    "GUARANTEE_EVENT": "تسجيل حدث على ضمان",
    "GUARANTEE_EXPIRE": "انتهاء ضمان",
    "DISMISS": "تجاهل ملاحظة",
    "UNDISMISS": "إنهاء التجاهل",
    "KEY_CHECK": "فحص مفتاح API",
    "RUN": "تشغيل المساعد",
    "SKIP": "تخطي موعد",
    "RUN_NOW": "إنشاء الموعد التالي مبكرًا",
    "END": "إنهاء",
    "ENROLL": "تسجيل في البرنامج",
    "TERMINATE": "إنهاء العقد",
    "RENEW": "تجديد",
    "EXPIRE": "انتهاء المدة",
    "PLAN_ADD": "إضافة خطة صيانة",
    "PLAN_UPDATE": "تعديل خطة صيانة",
    "GENERATE": "إنشاء أوامر الصيانة المخططة",
    "CHECK": "فحص معدّة",
    "FAULT": "فتح أمر عطل",
    "BILLING_REBUILD": "إعادة بناء الأقساط",
    "DEPOSIT": "إيداع",
    "CLEAR": "صرف",
    "BOUNCE": "ارتجاع",
    "HAND_BACK": "إعادة للعميل",
    "CHARGEBACK": "ارتجاع بعد الصرف",
    "UNDO": "تراجع"
  },
  "redacted": {
    "label": "محجوب",
    "why": "حُذفت وفق سياسة الاحتفاظ بالبيانات"
  }
}
